module.exports = __webpack_public_path__ + "media/images/pic/gallery/2018/warsztaty-chust-furoshiki-25e6e2a161ece5c3961ba583122437a4.jpg";